import {
    CREATE_WORKFLOW_ROUTE_REQUEST,
    CREATE_WORKFLOW_ROUTE_SUCCESS,
    CREATE_WORKFLOW_ROUTE_FAILURE,
    FETCH_WORKFLOW_ROUTES_REQUEST,
    FETCH_WORKFLOW_ROUTES_SUCCESS,
    FETCH_WORKFLOW_ROUTES_FAILURE,
    UPDATE_WORKFLOW_ROUTES_REQUEST,
    UPDATE_WORKFLOW_ROUTES_SUCCESS,
    UPDATE_WORKFLOW_ROUTES_FAILURE,
    ADD_WORKFLOW_ROUTE_PERMISSIONS_REQUEST,
    ADD_WORKFLOW_ROUTE_PERMISSIONS_SUCCESS,
    ADD_WORKFLOW_ROUTE_PERMISSIONS_FAILURE,
    FETCH_WORKFLOW_ROUTE_PERMISSIONS_REQUEST,
    FETCH_WORKFLOW_ROUTE_PERMISSIONS_SUCCESS,
    FETCH_WORKFLOW_ROUTE_PERMISSIONS_FAILURE,
    REMOVE_WORKFLOW_ROUTE_PERMISSIONS_REQUEST,
    REMOVE_WORKFLOW_ROUTE_PERMISSIONS_SUCCESS,
    REMOVE_WORKFLOW_ROUTE_PERMISSIONS_FAILURE,
    FETCH_WORKFLOW_ROUTE_ACTORS_REQUEST,
    FETCH_WORKFLOW_ROUTE_ACTORS_SUCCESS,
    FETCH_WORKFLOW_ROUTE_ACTORS_FAILURE
} from "./workflowRouteActionTypes";

// Import the axios instance from the API module
import api from "../../api/api";

// Import the react toastify library
import { toast } from "react-toastify";




// Define and export a function for creating routes for a workflow
export const createWorkflowRoute = (workflowRouteData) => {
    return async (dispatch) => {
        dispatch({ type: CREATE_WORKFLOW_ROUTE_REQUEST });

        try {
            // Make the API call with the array of workflow route objects
            const response = await api.post('/WorkflowRoute', workflowRouteData);

            dispatch({ type: CREATE_WORKFLOW_ROUTE_SUCCESS, payload: response.data });

            // Display a toast notification upon successful creation of the workflow routes
            toast.success("Workflow configured successfully");
        } catch (error) {
            // Handle different error cases
            if (error.response) {
                if (error.response.status === 400) {
                    dispatch({
                        type: CREATE_WORKFLOW_ROUTE_FAILURE,
                        payload: "Invalid data. Please check your input fields.",
                    });
                    toast.error("Workflow could not be configured due to invalid inputs. Please try again.");
                } else if (error.response.status === 500) {
                    dispatch({
                        type: CREATE_WORKFLOW_ROUTE_FAILURE,
                        payload: "Our server seems to be having issues. Please try again later.",
                    });
                    toast.error("Workflow could not be configured. Please try again.");
                } else {
                    dispatch({
                        type: CREATE_WORKFLOW_ROUTE_FAILURE,
                        payload: "An unknown error occurred. Please try again soon.",
                    });
                    toast.error("Workflow could not be configured. Please try again.");
                }
            } else if (error.request) {
                // The request was made but no response was received
                dispatch({
                    type: CREATE_WORKFLOW_ROUTE_FAILURE,
                    payload: "No response was received from the server. Please try again later.",
                });
                toast.error("No response from the server. Please try again later.");
            } else {
                // Something happened in setting up the request that triggered an error
                dispatch({
                    type: CREATE_WORKFLOW_ROUTE_FAILURE,
                    payload: "An error occurred while setting up the request. Please try again later.",
                });
                toast.error("An error occurred while setting up the request. Please try again.");
            }
        }
    };
};




// Define and export a function for fetching routes for a workflow using the workflow's id
export const fetchWorkflowRoutes = (workflowId) => {
    return async (dispatch) => {
        dispatch({ type: FETCH_WORKFLOW_ROUTES_REQUEST });

        try {
            const response = await api.get(`/WorkflowRoute/workflow/${workflowId}`);
            dispatch({ type: FETCH_WORKFLOW_ROUTES_SUCCESS, payload: response.data });

        } catch (error) {
            if (error.response) {
                // The request was made and the server responded with a status code that falls out of the range of 2xx
                if (error.response.status === 400) {
                    dispatch({ type: FETCH_WORKFLOW_ROUTES_FAILURE, payload: "Bad request. Please check your input." });
                    toast.error("Failed to fetch routes error 400");

                } else if (error.response.status === 404) {
                    dispatch({ type: FETCH_WORKFLOW_ROUTES_FAILURE, payload: "No assigned permission were found. Please try again later." });

                } else if (error.response.status === 500) {
                    dispatch({ type: FETCH_WORKFLOW_ROUTES_FAILURE, payload: "Our server seems to be having issues. Please try again later." });
                    toast.error("Failed to fetch routes error 500");

                } else {
                    dispatch({ type: FETCH_WORKFLOW_ROUTES_FAILURE, payload: "An unknown error occurred. Please try again soon." });
                }
            } else if (error.request) {
                // The request was made but no response was received
                dispatch({ type: FETCH_WORKFLOW_ROUTES_FAILURE, payload: "No response from the server. Please try again later." });
            } else {
                // Something happened in setting up the request that triggered an error
                dispatch({ type: FETCH_WORKFLOW_ROUTES_FAILURE, payload: "An error occurred while setting up the request. Please try again later." });
                toast.error("Failed to fetch routes other error code");
            }
        }
    };
};



// Define and export a function for fetching actors for a workflow route
export const fetchWorkflowRouteActors = (workflowId) => {
    return async (dispatch) => {
        dispatch({ type: FETCH_WORKFLOW_ROUTE_ACTORS_REQUEST });

        try {
            const response = await api.get(`/WorkflowRoute/workflow/${workflowId}/actors`);
      console.log("API Response for actors:", response.data);
            dispatch({ 
                type: FETCH_WORKFLOW_ROUTE_ACTORS_SUCCESS, 
                payload: response.data 
            });

        } catch (error) {
            if (error.response) {
                // The request was made and the server responded with a status code
                if (error.response.status === 400) {
                    dispatch({ 
                        type: FETCH_WORKFLOW_ROUTE_ACTORS_FAILURE, 
                        payload: "Bad request. Please check your input." 
                    });
                    toast.error("Failed to fetch actors - invalid request");

                } else if (error.response.status === 404) {
                    dispatch({ 
                        type: FETCH_WORKFLOW_ROUTE_ACTORS_FAILURE, 
                        payload: "No actors were found for this workflow." 
                    });

                } else if (error.response.status === 500) {
                    dispatch({ 
                        type: FETCH_WORKFLOW_ROUTE_ACTORS_FAILURE, 
                        payload: "Our server seems to be having issues. Please try again later." 
                    });
                    toast.error("Failed to fetch actors - server error");

                } else {
                    dispatch({ 
                        type: FETCH_WORKFLOW_ROUTE_ACTORS_FAILURE, 
                        payload: "An unknown error occurred. Please try again soon." 
                    });
                }
            } else if (error.request) {
                // The request was made but no response was received
                dispatch({ 
                    type: FETCH_WORKFLOW_ROUTE_ACTORS_FAILURE, 
                    payload: "No response from the server. Please try again later." 
                });
            } else {
                // Something happened in setting up the request
                dispatch({ 
                    type: FETCH_WORKFLOW_ROUTE_ACTORS_FAILURE, 
                    payload: "An error occurred while setting up the request. Please try again later." 
                });
                toast.error("Failed to fetch actors - request setup error");
            }
        }
    };
};




// Define and export a function for updating routes for a workflow using the workflow's id
export const updateWorkflowRoutes = (workflowId, updatedWorkflowRoutesData) => {
    return async (dispatch) => {
        dispatch({ type: UPDATE_WORKFLOW_ROUTES_REQUEST });

        try {
            const response = await api.put(`/WorkflowRoute/${workflowId}`, updatedWorkflowRoutesData);

            dispatch({ type: UPDATE_WORKFLOW_ROUTES_SUCCESS, payload: response.data });
            toast.success("Workflow updated successfully");
        
        } catch (error) {
            if (error.response) {
                if (error.response.status === 400) {
                    dispatch({ type: UPDATE_WORKFLOW_ROUTES_FAILURE, payload: "Invalid data. Please check your input fields." });
                    toast.error("Workflow configuration failed. Please try again.");
                } else if (error.response.status === 404) {
                    dispatch({ type: UPDATE_WORKFLOW_ROUTES_FAILURE, payload: "Workflow not found. Please try again" });
                    toast.error("The workflow you are trying to configure does not exist.");
                } else if (error.response.status === 500) {
                    dispatch({ type: UPDATE_WORKFLOW_ROUTES_FAILURE, payload: "Our server seems to be having issues. Please try again later." });
                    toast.error("Workflow route configuration failed. Please try again later.");
                } else {
                    dispatch({ type: UPDATE_WORKFLOW_ROUTES_FAILURE, payload: "An unknown error occurred. Please try again soon" });
                    toast.error("Workflow route configuration failed. Please try again.");
                }
            } else if (error.request) {
                dispatch({ type: UPDATE_WORKFLOW_ROUTES_FAILURE, payload: "No response was received from the server. Please try again later." })
            } else {
                dispatch({ type: UPDATE_WORKFLOW_ROUTES_FAILURE, payload: "An error occurred while setting up the request. Please try again later." })
            }
        }
    };
};










                         // Workflow permissions actions

// Define and export a function for fetching permissions for a workflow route or role
export const fetchWorkflowRoutesAssignedPermissions = (workflowId) => {
    return async (dispatch) => {
        dispatch({ type: FETCH_WORKFLOW_ROUTE_PERMISSIONS_REQUEST });

        try {
            const response = await api.get(`WorkflowPermissionConfig/GetByWorkflowId/${workflowId}`);
            dispatch({ type: FETCH_WORKFLOW_ROUTE_PERMISSIONS_SUCCESS, payload: response.data });

        } catch (error) {
            if (error.response) {
                // The request was made and the server responded with a status code that falls out of the range of 2xx
                if (error.response.status === 400) {
                    dispatch({ type: FETCH_WORKFLOW_ROUTE_PERMISSIONS_FAILURE, payload: "Bad request. Please check your input." });
                    toast.error("Failed to fetch workflow permissions error 400");

                } else if (error.response.status === 404) {
                    dispatch({ type: FETCH_WORKFLOW_ROUTE_PERMISSIONS_FAILURE, payload: "No assigned permission were found. Please try again later." });

                } else if (error.response.status === 500) {
                    dispatch({ type: FETCH_WORKFLOW_ROUTE_PERMISSIONS_FAILURE, payload: "Our server seems to be having issues. Please try again later." });
                    toast.error("Failed to fetch routes error 500");

                } else {
                    dispatch({ type: FETCH_WORKFLOW_ROUTE_PERMISSIONS_FAILURE, payload: "An unknown error occurred. Please try again soon." });
                }
            } else if (error.request) {
                // The request was made but no response was received
                dispatch({ type: FETCH_WORKFLOW_ROUTE_PERMISSIONS_FAILURE, payload: "No response from the server. Please try again later." });
            } else {
                // Something happened in setting up the request that triggered an error
                dispatch({ type: FETCH_WORKFLOW_ROUTE_PERMISSIONS_FAILURE, payload: "An error occurred while setting up the request. Please try again later." });
                toast.error("Failed to fetch workflow permissions other error code");
            }
        }
    };
}




// Define and export function for adding permissions to a workflow route or role
export const assignPermissionToWorkflow = (payload) => {
    return async (dispatch) => {
        dispatch({ type: ADD_WORKFLOW_ROUTE_PERMISSIONS_REQUEST });

        try {
            const response = await api.post('/WorkflowPermissionConfig/Create', payload);

            dispatch({ type: ADD_WORKFLOW_ROUTE_PERMISSIONS_SUCCESS, payload: response.data });

            toast.success("Permission added successfully");
        } catch (error) {
            if (error.response) {
                // The request was made and the server responded with a status code that falls out of the range of 2xx
                if (error.response.status === 400) {
                    dispatch({ type: REMOVE_WORKFLOW_ROUTE_PERMISSIONS_FAILURE, payload: "Bad request. Please check your input." });
                } else if (error.response.status === 404) {
                    dispatch({ type: REMOVE_WORKFLOW_ROUTE_PERMISSIONS_FAILURE, payload: "Permission could not be removed. Please try again later." });
                } else if (error.response.status === 500) {
                    dispatch({ type: REMOVE_WORKFLOW_ROUTE_PERMISSIONS_FAILURE, payload: "Our server seems to be having issues. Please try again later." });
                } else {
                    dispatch({ type: REMOVE_WORKFLOW_ROUTE_PERMISSIONS_FAILURE, payload: "An unknown error occurred. Please try again soon." });
                }
            } else if (error.request) {
                // The request was made but no response was received
                dispatch({ type: REMOVE_WORKFLOW_ROUTE_PERMISSIONS_FAILURE, payload: "No response from the server. Please try again later." });
            } else {
                // Something happened in setting up the request that triggered an error
                dispatch({ type: REMOVE_WORKFLOW_ROUTE_PERMISSIONS_FAILURE, payload: "An error occurred while setting up the request. Please try again later." });
            }
        }
    };
};





// Define and export function for removing permissions from a workflow route or role
export const removePermissionFromWorkflow = (workflowPermissionId) => {
    return async(dispatch) => {
        dispatch({ type: REMOVE_WORKFLOW_ROUTE_PERMISSIONS_REQUEST });

        try {
            const response = await api.delete(`/WorkflowPermissionConfig/delete/${workflowPermissionId}`);
            dispatch({ type: REMOVE_WORKFLOW_ROUTE_PERMISSIONS_SUCCESS, payload: response.data });

            toast.success("Permission removed successfully")
       
        } catch (error) {
            if (error.response) {
                // The request was made and the server responded with a status code that falls out of the range of 2xx
                if (error.response.status === 400) {
                    dispatch({ type: REMOVE_WORKFLOW_ROUTE_PERMISSIONS_FAILURE, payload: "Bad request. Please check your input." });
                } else if (error.response.status === 404) {
                    dispatch({ type: REMOVE_WORKFLOW_ROUTE_PERMISSIONS_FAILURE, payload: "Permission could not be removed. Please try again later." });
                } else if (error.response.status === 500) {
                    dispatch({ type: REMOVE_WORKFLOW_ROUTE_PERMISSIONS_FAILURE, payload: "Our server seems to be having issues. Please try again later." });
                } else {
                    dispatch({ type: REMOVE_WORKFLOW_ROUTE_PERMISSIONS_FAILURE, payload: "An unknown error occurred. Please try again soon." });
                }
            } else if (error.request) {
                // The request was made but no response was received
                dispatch({ type: REMOVE_WORKFLOW_ROUTE_PERMISSIONS_FAILURE, payload: "No response from the server. Please try again later." });
            } else {
                // Something happened in setting up the request that triggered an error
                dispatch({ type: REMOVE_WORKFLOW_ROUTE_PERMISSIONS_FAILURE, payload: "An error occurred while setting up the request. Please try again later." });
            }
        }
    };
};
